import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const MemberContext = createContext(null);

export const MemberProvider = ({ children }) => {
  const [member, setMember] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem("member_token") || "");
  const [loading, setLoading] = useState(true);

  const authHeaders = useCallback(() => ({ Authorization: `Bearer ${token}` }), [token]);

  const logout = useCallback(() => {
    setToken("");
    setMember(null);
    localStorage.removeItem("member_token");
  }, []);

  useEffect(() => {
    if (!token) { setLoading(false); return; }
    axios.get(`${API}/member/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setMember(r.data))
      .catch(() => { setToken(""); localStorage.removeItem("member_token"); })
      .finally(() => setLoading(false));
  }, [token]);

  const persist = (data) => {
    setToken(data.token);
    localStorage.setItem("member_token", data.token);
    setMember(data.member);
  };

  const login = async (phone, password) => {
    const r = await axios.post(`${API}/member/login`, { phone, password });
    persist(r.data);
    return r.data.member;
  };

  const register = async (payload) => {
    const r = await axios.post(`${API}/member/register`, payload);
    persist(r.data);
    return r.data.member;
  };

  const toggleFavorite = async (slug) => {
    const r = await axios.post(`${API}/member/favorites/${slug}`, {}, { headers: authHeaders() });
    setMember((m) => (m ? { ...m, favorites: r.data.favorites } : m));
    return r.data.favorites;
  };

  const isFavorite = (slug) => !!member?.favorites?.includes(slug);

  const updateProfile = async (payload) => {
    const r = await axios.put(`${API}/member/me`, payload, { headers: authHeaders() });
    setMember(r.data);
    return r.data;
  };

  return (
    <MemberContext.Provider value={{ member, token, loading, API, login, register, logout, toggleFavorite, isFavorite, updateProfile }}>
      {children}
    </MemberContext.Provider>
  );
};

export const useMember = () => useContext(MemberContext);
